import { render } from "./CentralUnitsList.vue?vue&type=template&id=f4c7a060&scoped=true"
import script from "./CentralUnitsList.vue?vue&type=script&lang=js"
export * from "./CentralUnitsList.vue?vue&type=script&lang=js"

import "./CentralUnitsList.vue?vue&type=style&index=0&id=f4c7a060&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c7a060"]])

export default __exports__